import type { FaireProductEntity } from "../../entity_types/product";

export const p_5wpbk2wf94: FaireProductEntity = {
  token: "p_5wpbk2wf94",
  type: "product",
  name: "Puka White Shell Necklace White Clam Surfer Necklace ",
  brandName: "Bedido Fashion",
  imageUrl:
    "https://cdn.faire.com/fastly/642a358b80c96aed76e4a41011cf31e88eb996f00f456851587da46b12f6ef8b.jpeg",
  priceDollars: 1.1,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/4fe801f6b892736ca70fdc068030873e50a77a0c8a2548817bd892f5450f28ad.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
